import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
		// 不建议在此配置路由，此文件是为了使业务项目禁用框架时，依然能够运行。
  ]
})
